import React, { useState, useEffect, useRef } from "react";
import Spinner from "../../components/Tools/spinner";
import { useSelector } from 'react-redux';
import { BankSettlementBeneficiaries } from "./../../helper/Api";
import DataTable from 'react-data-table-component';
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import moment from "moment";

const BankSettlementBeneficiariesApproved = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [bankMailRecords, setBankMailRecords] = useState([]);
    const customStyles = {
        headCells: {
        style: {
            fontWeight: "bold",
            fontSize: "14px"
        },
        },
    };
    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const DateDifference = (createdAt) => {
            const givenDate = moment(createdAt, "YYYY-MM-DD HH:mm:ss"); 
            const today = moment();

            // Difference in days
            const diffInDays = today.diff(givenDate, "days");

            return diffInDays;
        }

    const columns = [
        {
            name: 'S No',
            selector: (row) => row.id,
            width: "100px"
        },
        {
            name: 'Unique',
            selector: (row) => {
                return <span className="btn btn-warning">{row.bank_settlement_id}</span>
            },
            width: "100px"
        },
        {
            name: '+ Days',
            selector: (row) => {
                return <span>{DateDifference(row.created_at)}+</span>
            },
            width: "100px"
        },
        {
            name: 'Tran. Ref',
            selector: (row) => row.transaction_reference,
            width: "200px"
        },
        {
            name: 'Ach Tran. Code',
            selector: (row) => row.ach_transaction_code,
            sortable: true,
        },
        {
            name: 'Bene. Name',
            selector: (row) => row.beneficiary_name,
            sortable: true,
            wrap: true
        },
        {
            name: 'User Name',
            selector: (row) => row.user_name,
            sortable: true,
            wrap: true
        },
        {
            name: 'Amount',
            selector: (row) => Number(row.amount_paise) / 100,
            sortable: true,
            wrap: true
        },
        {
            name: 'Destination IFSC',
            selector: (row) => row.destination_ifsc_micr_iin,
            sortable: true,
            wrap: true
        },
        {
            name: 'Beneficiary Account No',
            selector: (row) => row.beneficiary_account_no,
            sortable: true,
            wrap: true
        },
        {
            name: 'Sponsor IFSC',
            selector: (row) => row.sponsor_ifsc_micr_iin,
            sortable: true,
            wrap: true
        },
        {
            name: 'User Number',
            selector: (row) => row.user_number,
            sortable: true,
            wrap: true
        },
        {
            name: 'Product Type',
            selector: (row) => row.product_type,
            sortable: true,
            wrap: true
        },
        {
            name: 'Created At',
            selector: (row) => row.created_at,
            sortable: true,
            wrap: true,
        }
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1);
    };

    const fetchBankSettlementBeneficiaries = async () => {
        try {
            setLoading(true);
            const res = await BankSettlementBeneficiaries({approved: true});
            if (res.data.status) {
                setBankMailRecords(res.data.data);
                setLoading(false);
            }
        } catch (error) {
            console.log("fetchBankSettlementBeneficiaries error", error);
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchBankSettlementBeneficiaries();
    }, []);

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Bank Settlement Beneficiaries Approved Report</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Bank Settlement Beneficiaries Approved Report"/>
                </div>
                <div className="col-md-6">
                    
                </div>
            </div>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                columns={columns}
                data={bankMailRecords}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationTotalRows={bankMailRecords.length}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    )
}

export default BankSettlementBeneficiariesApproved;